import './style.scss'

import React, { Component } from 'react'

import Button from 'components/UI/Button'
import NavItem from 'components/UI/NavItem'
import Navigation from 'components/UI/Navigation'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { logout } from 'actions/User'
import { withTranslation } from 'react-i18next'

class UserNavigation extends Component {
    render() {
        const { email, name, t, dispatch } = this.props
        return (
            <div className="user-navigation">
                {name && <h3 className="user-navigation__name">{name}</h3>}
                {email && <span className="user-navigation__email">{email}</span>}
                <Navigation type="dropdown">
                    <NavItem to="/my-page/orders">
                        {t('navigationMyPageNavigationDeliveries')}
                    </NavItem>
                    <NavItem to={'/my-page/addresses'}>{t('navigationMyPageAddresses')}</NavItem>
                    <NavItem to="/my-page/payment-methods">
                        {t('checkoutCheckoutEditPaymentTitle')}
                    </NavItem>
                    {process.env.FAQ_URL && (
                        <NavItem href={process.env.FAQ_URL}>
                            {t('navigationMyPageNavigationFAQ')}
                        </NavItem>
                    )}
                </Navigation>
                <Button
                    className="user-navigation__logout"
                    variant="text"
                    onClick={() => dispatch(logout())}
                >
                    {t('userNavigationLogout')}
                </Button>
            </div>
        )
    }
}

UserNavigation.propTypes = {
    email: PropTypes.string.isRequired,
    name: PropTypes.string,
    dispatch: PropTypes.func,
    t: PropTypes.func,
}

const mapStateToProps = ({ user }) => {
    let email = user.jwtData.spidEmail
    const name = `${user.spidData.givenName} ${user.spidData.familyName}`
    return { email, name }
}

export default connect(mapStateToProps)(withTranslation()(UserNavigation))
